<script setup lang="ts">
import heroBannersMock from './mocks'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay } from 'swiper/modules'
import { WidgetHeroBanner } from '~/components/widget/hero-banner'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import type { IHeroBanner } from '~/components/widget/hero-banner/types'
import 'swiper/css'
import 'swiper/css/pagination'

const config = useRuntimeConfig()
const heroBanners: IHeroBanner[] = heroBannersMock

const slideMinHeightClass =
  'h-full min-h-[calc(100vw*0.865)] min-[360px]:min-h-[calc(100vw*0.856)] min-[375px]:min-h-[calc(100vw*0.860)] min-[390px]:min-h-[calc(100vw*0.862)] min-[412px]:min-h-[calc(100vw*0.866)] min-[430px]:min-h-[calc(100vw*0.868)] md:min-h-[359px] 3xl:min-h-[398px]'
</script>

<template>
  <div v-if="heroBanners || config.public.reviveId">
    <Swiper
      :slides-per-view="1"
      :space-between="16"
      :modules="[Pagination, Autoplay]"
      :auto-height="true"
      :autoplay="{ delay: 5000, pauseOnMouseEnter: true }"
      :loop="true"
      :pagination="{ clickable: true }"
    >
      <SwiperSlide v-for="(banner, index) in heroBanners" :key="`hero-banner-${index}`">
        <WidgetHeroBanner
          :intro="$t(banner.intro)"
          :heading="$t(banner.heading)"
          :text="$t(banner.text)"
          :image="banner.image ? useAsset(banner.image) : null"
          :action-btn="banner.actionBtn"
          :additional-action-btn="banner.additionalActionBtn"
          :high-priority="index === 0"
          :class="[slideMinHeightClass, 'md:py-7']"
        />
      </SwiperSlide>

      <SwiperSlide
        v-if="config.public.reviveId"
        key="hero-ad"
        class="[&_img]:rounded-md [&_img]:border-2 [&_img]:border-blue-50 md:[&_img]:rounded-2xl"
      >
        <ClientOnly>
          <div :class="slideMinHeightClass">
            <WidgetReviveAd v-if="$device.isMobile" zoneid="32" />
            <WidgetReviveAd v-else zoneid="24" class="h-full" />
          </div>
        </ClientOnly>
      </SwiperSlide>
    </Swiper>
  </div>
  <div v-else class="h-[260px] rounded-lg bg-blue-50 sm:h-[326px] md:rounded-2xl lg:h-[360px]" />
</template>
